const s = {
  next: (e, n) => (e + 1) % n,
  previous: (e, n) => (e - 1 + n) % n,
  first: () => 0,
  last: (e, n) => n - 1
}, o = (e, n, t) => s[e](n, t);
export {
  o as getRovingIndex
};
